import React from "react";
import { styled } from '@mui/material/styles';
import Download from "./Download";

const PREFIX = 'Subcategory';

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    // margin: "1em 2.5em 1em 0",
    margin: "0.5em 1.5em 0.5em 0",
  },

  [`& .${classes.header}`]: {
    textTransform: "capitalize",
    color: "#999999",
    margin: "0.5em 0",
    display: "block",
    fontSize: "0.8rem",
  }
}));

const Subcategory = ({ subcategory, downloads }) => {


  return (
    <Root className={classes.root}>
		<div>
	      <span className={classes.header}>{subcategory}</span>
	      {downloads.map((download) => {
	        return <Download download={download} />;
	      })}
		</div>
    </Root>
  );
};

export default Subcategory;
